<div class="modal-body">
  <div class="modal-header-wrapper">
    <h2 class="title-text">Éditer un type d'événement</h2>
  </div>
  <div id="modal-content-wrapper">
    <div id="name-form" class="form-field">
      <label class="information-label-text">Nom du type d'événement</label>
      <input [(ngModel)]="diaryType.label" class="form-control"
             placeholder="Saisir le nom"
             type="text">
      <div class="invalid-feedback">
        Veuillez entrer un nom de type d'événement valide.
      </div>
    </div>
    <div id="hint-form" class="form-field mt8px">
      <label class="information-label-text">Conseil à la saisie de la description</label>
      <textarea [(ngModel)]="diaryType.hint"
                rows="4"
                class="form-control"
                placeholder="Ex.: Décrivez vos sensations de faim, la composition de votre repas, votre sensation de satiété..."
                type="text">
      </textarea>
      <div class="invalid-feedback">
        Veuillez entrer un conseil à la saisie valide.
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <ng-container>
    <button (click)="hideModal()" type="button"
            class="btn btn-outline-primary btn-outline text-only">
      Annuler
    </button>

    <button (click)="validate()" [disabled]="!enabledValidate()" class="btn btn-primary btn-gradient">
      <ng-container *ngIf="isLoading else validateButton">
        <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
        <span class="visually-hidden">Chargement...</span>
      </ng-container>
      <ng-template #validateButton>
        Valider
      </ng-template>
    </button>
  </ng-container>
</div>
